// extracted by mini-css-extract-plugin
export default {"chip":"ColorTag_chip__-zScX","color":"ColorTag_color__zx32I"};